import React from 'react';
import { Form, Select } from 'antd';

interface WorkLocationFieldProps {
  unitsList: any[];
  form: any;
  className?: string;
}

/**
 * Shared WorkLocationField component for AddUser and EditUser forms
 * Displays a multi-select location field that is disabled when consultant checkbox is checked
 */
const WorkLocationField: React.FC<WorkLocationFieldProps> = ({
  unitsList,
  form,
  className = '',
}) => {
  const consultantValue = Form.useWatch('consultant', form);

  return (
    <Form.Item
      className={className}
      label="Work Location"
      name="user_unit_name"
      dependencies={['consultant']}
      rules={[
        ({ getFieldValue }) => ({
          validator(_, value) {
            const isConsultant = getFieldValue('consultant');
            // If consultant is checked, location is optional
            if (isConsultant) {
              return Promise.resolve();
            }
            // If consultant is not checked, location is required
            if (!value || value.length === 0) {
              return Promise.reject(new Error('Please select unit!'));
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Select
        placeholder="Select Unit"
        options={unitsList}
        allowClear
        mode="multiple"
        disabled={consultantValue}
      />
    </Form.Item>
  );
};

export default WorkLocationField;
